<template>
  <div>
    <div class="flex justify-center items-center pt-2 pb-4 fixed w-full backgroundImage z-40 px-2">
      <a class="absolute inline-flex top-4 left-2 text-sm text-link" @click="$emit('close')">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"></path></svg>
        <span>{{ $t('tour_back') }}</span>
      </a>
      <h1 class="section-title">{{ $t('tour_filter_title') }}</h1>
    </div>
    <div class="px-2 pt-12">
      <div class="bg-white border border-pale_green border-b-0 rounded">
        <filter-button
          :items="genres"
          :isItemsOpen="true"
          :fontWeight="'font-bold'" />
      </div>
      <div class="mt-4 w-full px-2">
        <a class="button-primary block w-half float-right" @click="onFilterAllOn">{{ $t('tour_filter_all_on') }}</a>
        <a class="button-secondary block w-half" @click="onFilterAllOff">{{ $t('tour_filter_all_off') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FilterButton from './FilterButton'

export default {
  components: {
    FilterButton
  },
  computed: {
    ...mapGetters({
      genres: 'genres/getAll'
    })
  },
  methods: {
    onFilterAllOn: function () {
      this.$store.dispatch('user/onFilterAll')
    },
    onFilterAllOff: function () {
      this.$store.dispatch('user/offFilterAll')
    }
  }
}
</script>
